export default {"src":"/_next/static/media/train_40.fc6f74d6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};